import bmp from "../assets/icons/bmp.svg";
import csv from "../assets/icons/csv.svg";
import doc from "../assets/icons/doc.svg";
import docx from "../assets/icons/docx.svg";
import gif from "../assets/icons/gif.svg";
import jpeg from "../assets/icons/jpeg.svg";
import jpg from "../assets/icons/jpg.svg";
import pdf from "../assets/icons/pdf.svg";
import png from "../assets/icons/png.svg";
import xlsx from "../assets/icons/xlsx.svg";
import { APP_ENV, USER_TYPE } from "../constant";

const employerAppUrl = process.env.REACT_APP_P3_EMPLOYER_URL;
const talentAppUrl = process.env.REACT_APP_P3_CANDIDATE_URL;
const env = process.env.REACT_APP_ENV;

export const impersonate = (type, id, redirectTo = false) => {
  let url = `${type === USER_TYPE.EMPLOYER ? employerAppUrl : talentAppUrl}/${type}/auth?userId=${id}&token=${localStorage.getItem("ACCESS_TOKEN")}`;
  if (env === APP_ENV.STAGE) {
    url = `${type === USER_TYPE.EMPLOYER ? employerAppUrl : talentAppUrl}/auth?userId=${id}&token=${localStorage.getItem("ACCESS_TOKEN")}`;
  }
  if (redirectTo) {
    url += `&redirectTo=${redirectTo}`;
  }
  window.open(url, "_blank");
};

export const setOptionValues = (data) => {
  let options = [];
  data.forEach((obj, index) => {
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        if (obj[key] > 0) {
          options.push({ label: key, value: obj[key] });
        }
      }
    }
  });

  return options;
};

export const getFileIcon = (extension) => {
  switch (extension) {
    case "bmp":
      return bmp;
    case "csv":
      return csv;
    case "doc":
      return doc;
    case "docx":
      return docx;
    case "gif":
      return gif;
    case "jpeg":
      return jpeg;
    case "jpg":
      return jpg;
    case "pdf":
      return pdf;
    case "png":
      return png;
    case "xlsx":
      return xlsx;
    default:
      return null;
  }
};

export const getFileExtension = (fileName) => {
  const dotIndex = fileName?.lastIndexOf(".") + 1;
  const extension = fileName?.slice(dotIndex);
  return extension;
};

export const getFormattedFileSize = (sizeInBytes) => {
  const units = ['Bytes', 'KB', 'MB', 'GB'];
  let unitIndex = 0;
  while (sizeInBytes > 900 && unitIndex < units.length - 1) {
    sizeInBytes /= 1024;
    unitIndex++;
  }
  const roundedSize = Math.round(sizeInBytes * 100) / 100;
  return `${roundedSize} ${units[unitIndex]}`;
};

export const isMobile = () => {
  return /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

export const getStatusStyle = (status) => {
  switch (status?.toLowerCase()) {
    case "active":
      return { color: "#52c41a", textTransform: "capitalize", cursor: "pointer" }; // green
    case "inactive":
      return { color: "#f00", textTransform: "capitalize", cursor: "pointer" }; // gray
    case "deploying":
      return { color: "#faad14", textTransform: "capitalize", cursor: "pointer" }; // orange
    default:
      return { color: "#000", textTransform: "capitalize", cursor: "pointer" };
  }
};